<template>
  <v-layout row wrap fill-height class="team">
    <v-flex>
      <v-card>
        <v-form ref="team-form">
          <v-card-title>
            <h3>App Settings:</h3>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 lg6>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      outline
                      label="Team Name"
                      v-model="form.name"
                      name="name"
                      :hide-details="!errors.has('name')"
                      :error="errors.has('name')"
                      :error-count="errors.count('name')"
                      :error-messages="errors.get('name')"
                      @change="errors.clear('name')"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      outline
                      label="App Name"
                      v-model="form.team_settings.app_name"
                      name="app_name"
                      :hide-details="!errors.has('app_name')"
                      :error="errors.has('app_name')"
                      :error-count="errors.count('app_name')"
                      :error-messages="errors.get('app_name')"
                      @change="errors.clear('app_name')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 lg6>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-select
                      v-model="form.defaultRoleId"
                      outline
                      label="Default User Role"
                      :items="ROLES"
                      item-text="name"
                      item-value="id"
                      name="default_role_id"
                      :hide-details="!errors.has('default_role_id')"
                      :error="errors.has('default_role_id')"
                      :error-count="errors.count('default_role_id')"
                      :error-messages="errors.get('default_role_id')"
                      @change="errors.clear('default_role_id')"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                      outline
                      label="Default Modifier"
                      v-model="form.defaultModifier"
                      name="modifier"
                      :hide-details="!errors.has('state')"
                      :error="errors.has('state')"
                      :error-count="errors.count('state')"
                      :error-messages="errors.get('state')"
                      @change="errors.clear('state')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-title>
            <h3>Surcharge Settings:</h3>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 lg4>
                <v-autocomplete
                  v-model="form.team_settings.applysurcharge"
                  item-text="name"
                  item-value="id"
                  :items="applysurcharge"
                  label="Apply Surcharge"
                  placeholder="Apply Surcharge"
                  multiple
                  hide-details
                  :small-chips="$vuetify.breakpoint.smAndUp"
                  outline
                  clearable
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 lg8>
                <v-layout wrap>
                  <v-flex xs12 md4>
					   <v-text-field
                  outline
                  label="Default surcharge"
                  v-model="form.team_settings.surcharge"
                  name="surcharge"
                  persistent-hint
                  :hide-details="!errors.has('surcharge')"
                  :error="errors.has('surcharge')"
                  :error-count="errors.count('surcharge')"
                  :error-messages="errors.get('surcharge')"
                  @change="errors.clear('surcharge')"
                ></v-text-field>

                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-title>
            <h3>Address:</h3>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 lg4>
                <v-text-field
                  outline
                  label="Street Address"
                  v-model="form.team_settings.address"
                  name="address"
                  :hide-details="!errors.has('address')"
                  :error="errors.has('address')"
                  :error-count="errors.count('address')"
                  :error-messages="errors.get('address')"
                  @change="errors.clear('address')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 lg8>
                <v-layout wrap>
                  <v-flex xs12 md4>
                    <v-text-field
                      outline
                      label="City"
                      v-model="form.team_settings.city"
                      name="city"
                      :hide-details="!errors.has('city')"
                      :error="errors.has('city')"
                      :error-count="errors.count('city')"
                      :error-messages="errors.get('city')"
                      @change="errors.clear('city')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-autocomplete
                      label="State"
                      outline
                      v-model="form.team_settings.state"
                      :items="states"
                      item-text="name"
                      item-value="abbreviation"
                      clearable
                      browser-autocomplete="disabled"
                      name="state"
                      :hide-details="!errors.has('state')"
                      :error="errors.has('state')"
                      :error-count="errors.count('state')"
                      :error-messages="errors.get('state')"
                      @change="errors.clear('state')"
                      v-if="states"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      outline
                      label="Zip"
                      v-model="form.team_settings.zip"
                      name="zip"
                      :hide-details="!errors.has('zip')"
                      :error="errors.has('zip')"
                      :error-count="errors.count('zip')"
                      :error-messages="errors.get('zip')"
                      @change="errors.clear('zip')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-title>
            <h3>Email Settings:</h3>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  outline
                  label="From Name"
                  v-model="form.team_settings.from_name"
                  name="from_name"
                  :hide-details="!errors.has('from_name')"
                  :error="errors.has('from_name')"
                  :error-count="errors.count('from_name')"
                  :error-messages="errors.get('from_name')"
                  @change="errors.clear('from_name')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  outline
                  label="From Address"
                  v-model="form.team_settings.from_address"
                  name="from_address"
                  :hide-details="!errors.has('from_address')"
                  :error="errors.has('from_address')"
                  :error-count="errors.count('from_address')"
                  :error-messages="errors.get('from_address')"
                  @change="errors.clear('from_address')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-title>
            <h3>Order Contact Information:</h3>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  outline
                  label="Order Email Address"
                  type="email"
                  v-model="form.team_settings.order_email"
                  name="order_email"
                  :hide-details="!errors.has('order_email')"
                  :error="errors.has('order_email')"
                  :error-count="errors.count('order_email')"
                  :error-messages="errors.get('order_email')"
                  @change="errors.clear('order_email')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  outline
                  label="Order Phone Number"
                  mask="phone"
                  v-model="form.team_settings.order_phone"
                  name="order_phone"
                  :hide-details="!errors.has('order_phone')"
                  :error="errors.has('order_phone')"
                  :error-count="errors.count('order_phone')"
                  :error-messages="errors.get('order_phone')"
                  @change="errors.clear('order_phone')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  outline
                  label="Order CC Email Address(es)"
                  v-model="form.team_settings.order_cc_email"
                  name="order_cc_email"
                  hint="comma separated"
                  persistent-hint
                  :hide-details="!errors.has('order_cc_email')"
                  :error="errors.has('order_cc_email')"
                  :error-count="errors.count('order_cc_email')"
                  :error-messages="errors.get('order_cc_email')"
                  @change="errors.clear('order_cc_email')"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  outline
                  label="Order BCC Email Address(es)"
                  v-model="form.team_settings.order_bcc_email"
                  name="order_bcc_email"
                  hint="comma separated"
                  persistent-hint
                  :hide-details="!errors.has('order_bcc_email')"
                  :error="errors.has('order_bcc_email')"
                  :error-count="errors.count('order_bcc_email')"
                  :error-messages="errors.get('order_bcc_email')"
                  @change="errors.clear('order_bcc_email')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  outline
                  label="SAP Email Address(es)"
                  v-model="form.team_settings.sap_email"
                  name="sap_email"
                  hint="comma separated"
                  persistent-hint
                  :hide-details="!errors.has('sap_email')"
                  :error="errors.has('sap_email')"
                  :error-count="errors.count('sap_email')"
                  :error-messages="errors.get('sap_email')"
                  @change="errors.clear('sap_email')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-title>
            <h3>Logos:</h3>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <image-select
                  v-model="form.logos.light"
                  :reset.sync="resetImages"
                  :src="currentTeam.photo_url"
                  label="Light"
                  name="logo_light"
                  :hide-details="!errors.has('logo_light')"
                  :error="errors.has('logo_light')"
                  :error-count="errors.count('logo_light')"
                  :error-messages="errors.get('logo_light')"
                  @change="errors.clear('logo_light')"
                ></image-select>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <image-select
                  v-model="form.logos.dark"
                  :reset.sync="resetImages"
                  :src="currentTeam.photo_url_dark"
                  label="Dark"
                  name="logo_dark"
                  :hide-details="!errors.has('logo_dark')"
                  :error="errors.has('logo_dark')"
                  :error-count="errors.count('logo_dark')"
                  :error-messages="errors.get('logo_dark')"
                  @change="errors.clear('logo_dark')"
                ></image-select>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-title>
            <h3>Colors:</h3>
          </v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md4 v-for="color in modifiableColors" :key="color">
                <color-input
                  v-model="form.team_settings.theme[color.toLowerCase()]"
                  :label="color"
                  :name="color.toLowerCase()"
                ></color-input>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-actions class="px-3 pt-0 pb-3">
            <v-spacer></v-spacer>
            <v-btn @click="reset">Reset</v-btn>
            <v-btn :loading="loading" color="primary" @click="save"
              >Save Settings</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
      <!-- <code>{{errors}}</code> -->
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import ImageSelect from "@components/partials/ImageSelect";
import ColorInput from "@components/partials/ColorInput";
import Errors from "@root/helpers/Errors";

export default {
  data() {
    return {
      modifiableColors: ["Primary", "Secondary", "Tertiary"],
      form: {
        name: "",
        app_name: "",
        logos: {
          light: null,
          dark: null,
        },
        defaultRoleId: null,
        defaultModifier: "",
        team_settings: {
          theme: {},
          app_name: "",
          from_name: "",
          from_address: "",
          order_email: "",
          order_phone: "",
          address: "",
          city: "",
          state: "",
          zip: "",
          order_cc_email: "",
          order_bcc_email: "",
          sap_email: "",
		  surcharge : "",
		  applysurcharge:[]
        },
      },
      resetImages: false,
      errors: new Errors(),
      loading: false,

	  applysurcharge: [],
    };
  },

  components: { ColorInput, ImageSelect },

  computed: {
    ...mapGetters(["user", "currentTeam", "theme", "dark", "statesList"]),

    ...mapGetters("admin", {
      ROLES: "roles",
    }),

    availableAttachments() {
      return ".jpg, .jpeg, .png, .gif, .svg";
    },

    imageWidth() {
      return 200;
    },

    imageHeight() {
      return 200;
    },

    states() {
      return this.statesList("US");
    },
  },
mounted () {

	this.getSurcharge();

  },
  methods: {
    ...mapActions(["setTeamSettingValue", "setTeamPropertyValue"]),

    ...mapActions("admin", {
      GET_ROLES: "getRoles",
    }),

    ...mapMutations(["SET_VALUE"]),

	getSurcharge(){
		axios
			.get(`/api/get_category`)
			.then(response => {
				this.applysurcharge = response.data
			})
			.catch(error => {
				this.errored = true
			})
			.finally(() => this.loading = false)
	},

    save() {
      this.loading = true;
      this.setTeamPropertyValue({
        name: this.form.name,
        default_role_id: this.form.defaultRoleId,
        default_modifier: this.form.defaultModifier,
      }).catch((error) => {
        error = Object.assign({}, error);
        this.errors.record(error.response.data.errors);
      });

      this.setTeamSettingValue({
        app_name: this.form.team_settings.app_name,
        address: this.form.team_settings.address,
        city: this.form.team_settings.city,
        state: this.form.team_settings.state,
        zip: this.form.team_settings.zip,
        from_name: this.form.team_settings.from_name,
        from_address: this.form.team_settings.from_address,
        order_email: this.form.team_settings.order_email,
        order_phone: this.form.team_settings.order_phone,
        order_cc_email: this.form.team_settings.order_cc_email,
        order_bcc_email: this.form.team_settings.order_bcc_email,
        theme: this.form.team_settings.theme,
        sap_email: this.form.team_settings.sap_email,
		surcharge: this.form.team_settings.surcharge,
		applysurcharge: this.form.team_settings.applysurcharge
      })
        .then(() => {
          this.$swal({
            title: "Save Successful",
            text: "Settings saved successfully!",
            type: "success",
            confirmButtonText: "Okay",
          });
        })
        .catch((error) => {
          error = Object.assign(
            {},
            this.errors.errors,
            error.response.data.errors
          );
          this.errors.record(error);
        })
        .finally(() => {
          this.loading = false;
        });

      this.uploadLogos();
    },

    reset() {
      // Images
      this.$set(this, "resetImages", true);

      // Colors
      _.forIn(this.theme, (color, key) => {
        this.$set(this.form.colors, key, color);
        this.$vuetify.theme[key] = color;
      });
    },

    uploadLogos() {
      if (this.form.logos.light || this.form.logos.dark) {
        let formData = new FormData();

        _.forEach(this.form.logos, (logo, key) => {
          if (logo) {
            let location = key !== "dark" ? "photo" : "photo_dark";

            formData.append(location, logo);
          }
        });

        axios
          .post("/api/team/logo", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(({ data }) => {
            this.SET_VALUE({
              name: "currentTeam.photo_url",
              value: data.photo_url,
            });
          })
          .catch((error) => {
            error = Object.assign(
              {},
              this.errors.errors,
              error.response.data.errors
            );
            this.errors.record(error);
          });
      }
    },
  },

  created() {
    // App Settings
    _.forEach(this.form.team_settings, (value, key) => {
      if (key !== "theme") {
        this.$set(
          this.form.team_settings,
          key,
          this.currentTeam.team_settings[key]
        );
      } else {
        // Colors
        let colors = {};
        Object.assign(colors, this.theme);
        _.forIn(colors, (color, key) => {
          this.$set(this.form.team_settings.theme, key, color);
        });
      }
    });
    this.$set(this.form, "name", this.currentTeam.name);

    this.$set(this.form, "defaultRoleId", this.currentTeam.default_role_id);

    this.$set(this.form, "defaultModifier", this.currentTeam.default_modifier);

    this.GET_ROLES();
  },
};
</script>
